import React, {forwardRef} from 'react';

import Head from '../Head';
import Foot from '../Foot';
import Body from '../Body';

const Table = forwardRef((props, ref) => (
    <table className="responsive" ref={ref}>
        <Head {...props} />
        <Foot {...props} />
        <Body />
    </table>
));

export default Table;
